import envVars from 'env-vars';

export type FirebaseConfig = {
  apiKey: string;
  authDomain: string;
  projectId: string;
  storageBucket: string;
  messagingSenderId: string;
  appId: string;
  measurementId?: string;
};

// Firebase web config values are public, but repo audits still flag them, so they
// are no longer hardcoded here. Each environment's config is injected at build time
// as a JSON string (gitignored .env locally, CI/build secrets in deployments) and
// selected at runtime by REACT_APP_NODE_ENV (which env-vars resolves from the
// microservice-served window.ENV_* first, falling back to the build-time value).
// All three are referenced statically so Vite inlines every block into the bundle,
// preserving the previous behaviour where one build can serve any environment.
const rawConfigByEnv: Record<string, string | undefined> = {
  staging: import.meta.env.REACT_APP_FIREBASE_CONFIG_STAGING,
  production: import.meta.env.REACT_APP_FIREBASE_CONFIG_PRODUCTION,
  rc: import.meta.env.REACT_APP_FIREBASE_CONFIG_RC,
};

const getFirebaseConfig = (): FirebaseConfig => {
  const env = envVars.REACT_APP_NODE_ENV || 'staging';
  const raw = rawConfigByEnv[env] || rawConfigByEnv.staging;

  if (!raw) {
    throw new Error(
      `[firebase] Missing Firebase config for env "${env}". Set ` +
        'REACT_APP_FIREBASE_CONFIG_STAGING / _RC / _PRODUCTION at build time ' +
        '(gitignored .env locally, CI/build secrets in deployments).'
    );
  }

  let parsed: FirebaseConfig;
  try {
    parsed = JSON.parse(raw);
  } catch (error) {
    throw new Error(
      `[firebase] REACT_APP_FIREBASE_CONFIG for env "${env}" is not valid JSON.`
    );
  }

  if (!parsed.apiKey || !parsed.projectId) {
    throw new Error(
      `[firebase] Firebase config for env "${env}" is missing required fields (apiKey/projectId).`
    );
  }

  return parsed;
};

export default getFirebaseConfig;
